(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4799],{

/***/ 81542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[slug]/[id]",
      function () {
        return __webpack_require__(94283);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ TagsFilter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/images/cross-x.svg
var cross_x_namespaceObject = __webpack_require__.p + "static/images/cross-x.svg";
;// CONCATENATED MODULE: ./src/@next/components/atoms/TagCheckbox/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin: 5.5px 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 36px;\n    padding-bottom: 4px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 2px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 8px;\n      height: 8px\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 46px;\n  font-size: ",
        ";\n  line-height: 100%;\n  border-radius: 23px;\n  box-shadow: inset 0px 0px 0px 2px #eaeaea;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px 6px;\n  color: ",
        ";\n  ",
        "\n  ",
        "\n  ::after {\n    margin-left: 6px;\n    content: '';\n    display: none;\n    width: 14px;\n    height: 14px;\n    background: url(",
        ");\n    background-size: contain;\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  input[type='checkbox'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    ",
        ":hover & {\n      ",
        " {\n        background: #f9edec;\n        box-shadow: none;\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    ",
        " {\n      background: #c34c3e;\n      box-shadow: none;\n      color: #ffffff;\n      ::after {\n        display: block;\n      }\n    }\n\n    &:hover {\n      ",
        " {\n        background: #c9c9c9;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var TagCheckbox = globalStyles/* styled.div */.zo.div(_templateObject());
var LabelInner = globalStyles/* styled.span */.zo.span(_templateObject4(), function(props) {
    return props.theme.typography.h5FontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()), cross_x_namespaceObject, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()));
var Label = globalStyles/* styled.label */.zo.label(_templateObject5(), TagCheckbox, LabelInner, LabelInner, LabelInner, function(props) {
    return props.theme.colors.baseFont;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/TagCheckbox/TagCheckbox.tsx
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 






var ENTER_KEY = 13;
var SPACE_KEY = 32;
var TagCheckbox_TagCheckbox = function(_param) {
    var name = _param.name, checked = _param.checked, value = _param.value, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "checked",
        "value",
        "onChange"
    ]);
    var ref = react.useRef(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCheckbox, {
        ref: ref,
        onClick: function(evt) {
            evt.preventDefault();
            onChange(evt);
            if (ref.current) {
                ref.current.blur();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    tabIndex: -1,
                    type: "checkbox",
                    name: name,
                    checked: checked,
                    readOnly: true
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref,
                    tabIndex: 0,
                    onKeyDown: function(evt) {
                        if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                            evt.preventDefault();
                            onChange(evt);
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelInner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (0,translations/* translate */.I)(value, "name").replace("_", " ")
                        })
                    })
                })
            ]
        })
    });
};
TagCheckbox_TagCheckbox.displayName = "TagCheckbox";

;// CONCATENATED MODULE: ./src/@next/components/atoms/TagCheckbox/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/TagsFilter/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin: -5.5px -3px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject());

;// CONCATENATED MODULE: ./src/@next/components/molecules/TagsFilter/TagsFilter.tsx




var TagsFilter = function(param) {
    var name = param.name, values = param.values, onValueClick = param.onValueClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: values && values.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCheckbox_TagCheckbox, {
                name: name,
                checked: !!value.selected,
                onChange: function() {
                    return onValueClick(value);
                },
                value: value
            }, value.id);
        })
    });
};
TagsFilter.displayName = "TagsFilter";

;// CONCATENATED MODULE: ./src/@next/components/molecules/TagsFilter/index.ts



/***/ }),

/***/ 61514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ mapEdgesToItems; }
/* harmony export */ });
function mapEdgesToItems(data) {
    var ref;
    return (data === null || data === void 0 ? void 0 : (ref = data.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var node = param.node;
        return node;
    })) || [];
}


/***/ }),

/***/ 94283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@next/hooks/index.ts + 8 modules
var hooks = __webpack_require__(78544);
// EXTERNAL MODULE: ./src/@next/hooks/useQueryState/index.ts + 3 modules
var useQueryState = __webpack_require__(86534);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 4 modules
var regions = __webpack_require__(34465);
// EXTERNAL MODULE: ./src/@next/utils/misc.ts
var misc = __webpack_require__(96896);
// EXTERNAL MODULE: ./src/@next/utils/maps.ts
var maps = __webpack_require__(61514);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./src/@next/components/atoms/Loader/index.ts + 2 modules
var Loader = __webpack_require__(35582);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/views/Collection/utils.ts





var filtersChangeHandler = function(filters, attributeFilters, setAttributeFilters) {
    return function(name, value) {
        if (Array.isArray(value)) {
            // handle range of values
            setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, "".concat(name), value)));
            return;
        }
        if (value === null) {
            // handle clear filter
            var att = (0,_object_spread/* default */.Z)({}, attributeFilters);
            delete att["".concat(name)];
            setAttributeFilters((0,_object_spread/* default */.Z)({}, att));
            return;
        }
        if (attributeFilters && attributeFilters.hasOwnProperty(name)) {
            if (attributeFilters[name].includes(value)) {
                if (filters.attributes[name].length === 1) {
                    var att1 = (0,_object_spread/* default */.Z)({}, attributeFilters);
                    delete att1[name];
                    setAttributeFilters((0,_object_spread/* default */.Z)({}, att1));
                } else {
                    setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, name, attributeFilters[name].filter(function(item) {
                        return item !== value;
                    }))));
                }
            } else {
                setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, name, (0,_to_consumable_array/* default */.Z)(attributeFilters[name]).concat([
                    value
                ]))));
            }
        } else {
            setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, name, [
                value
            ])));
        }
    };
};
var parseQueryAttributeFilters = function(query) {
    var filters = {};
    if (query == null || query === "") {
        return filters;
    }
    var keyValSeparator = "_";
    var keyValSubSeparator = "--";
    var entrySeparator = ".";
    var propsWithValues = query.split(entrySeparator).filter(function(n) {
        return n;
    });
    propsWithValues.map(function(tuple) {
        var propWithValues = tuple.split(keyValSeparator).filter(function(n) {
            return n;
        });
        filters[propWithValues[0]] = propWithValues.slice(1).map(function(v) {
            return v.replace(keyValSubSeparator, keyValSeparator);
        });
    });
    return filters;
};
var serializeQueryAttributeFilters = function(values) {
    var str = [];
    var keyValSeparator = "_";
    var keyValSubSeparator = "--";
    var entrySeparator = ".";
    Object.entries(values).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        str.push("".concat(key).concat(keyValSeparator).concat(value.map(function(v) {
            return v.replace(keyValSeparator, keyValSubSeparator);
        }).join(keyValSeparator)));
    });
    return str.join(entrySeparator);
};

// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@next/components/organisms/ProductList/index.ts + 6 modules
var ProductList = __webpack_require__(27453);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(11700);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@next/components/atoms/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(73881);
// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeValuesChecklist/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80%;\n  padding-bottom: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  padding-bottom: 1.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  width: 95%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 1.25rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject());
var Header = globalStyles/* styled.div */.zo.div(_templateObject1(), function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.boldFontWeight;
});
var BottomBorder = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.colors.divider;
});
var ViewMoreButton = globalStyles/* styled.div */.zo.div(_templateObject3());

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeValuesChecklist/AttributeValuesChecklist.tsx







var AttributeValuesChecklist = function(param) {
    var // title,
    name = param.name, values = param.values, _valuesShowLimit = param.valuesShowLimit, valuesShowLimit = _valuesShowLimit === void 0 ? false : _valuesShowLimit, _valuesShowLimitNumber = param.valuesShowLimitNumber, valuesShowLimitNumber = _valuesShowLimitNumber === void 0 ? 5 : _valuesShowLimitNumber, onValueClick = param.onValueClick;
    var ref = (0,react.useState)(!valuesShowLimit), viewAllOptions = ref[0], setViewAllOptions = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            values && values.map(function(value, index) {
                return !viewAllOptions && index > valuesShowLimitNumber - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                    name: name,
                    checked: !!value.selected,
                    onChange: function() {
                        return onValueClick(value);
                    },
                    children: (0,translations/* translate */.I)(value, "name").replace("_", " ")
                }, value.id);
            }),
            !viewAllOptions && values.length > valuesShowLimitNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    appearance: "ghost",
                    size: "sm",
                    color: "secondary",
                    onClick: function() {
                        return setViewAllOptions(true);
                    },
                    children: intl.formatMessage({
                        defaultMessage: "VIEW ALL OPTIONS",
                        id: "YQVUHR"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBorder, {})
        ]
    });
};
AttributeValuesChecklist.displayName = "AttributeValuesChecklist";

;// CONCATENATED MODULE: ./src/@next/components/molecules/AttributeValuesChecklist/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@next/utils/colorsDictionary.ts
var colorsDictionary = __webpack_require__(61675);
// EXTERNAL MODULE: ./src/core/utils.ts
var utils = __webpack_require__(10110);
// EXTERNAL MODULE: ./src/@next/components/organisms/Popover/index.ts + 5 modules
var Popover = __webpack_require__(93290);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/images/check.svg
var check = __webpack_require__(45809);
// EXTERNAL MODULE: ./src/images/cross.svg
var cross = __webpack_require__(45747);
;// CONCATENATED MODULE: ./src/@next/components/atoms/ColorCheckbox/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin: 3px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  input[type='checkbox'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    span {\n      border-radius: 50%;\n      width: 46px;\n      height: 46px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .color-checkbox__icon {\n        &-check,\n        &-cross {\n          display: none;\n        }\n      }\n    }\n\n    ",
        ":hover & {\n      span {\n        border: 4px solid rgba(255, 255, 255, 0.3);\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    span {\n      border: 4px solid rgba(255, 255, 255, 0.3);\n      .color-checkbox__icon {\n        &-check {\n          display: block;\n        }\n      }\n    }\n    &:hover {\n      span {\n        .color-checkbox__icon {\n          &-check {\n            display: none;\n          }\n          &-cross {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ColorCheckbox = globalStyles/* styled.div */.zo.div(styles_templateObject());
var Label = globalStyles/* styled.label */.zo.label(styles_templateObject1(), ColorCheckbox);

;// CONCATENATED MODULE: ./src/@next/components/atoms/ColorCheckbox/ColorCheckbox.tsx
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 















var ENTER_KEY = 13;
var SPACE_KEY = 32;
var ColorCheckbox_ColorCheckbox = function(_param) {
    var name = _param.name, checked = _param.checked, value = _param.value, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? false : _tooltip, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "checked",
        "value",
        "onChange",
        "tooltip"
    ]);
    var ref = react.useRef(null);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref1[0];
    var tooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        style: {
            backgroundColor: value.color || colorsDictionary/* colorsDictionary */.X[value.slug],
            backgroundImage: "url(".concat((0,utils/* getTextureThumbnailUrl */.g)(value.slug), ")"),
            backgroundSize: "cover"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: check,
                className: "color-checkbox__icon-check"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: cross,
                className: "color-checkbox__icon-cross"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorCheckbox, {
        ref: ref,
        onClick: function(evt) {
            evt.preventDefault();
            onChange(evt);
            if (ref.current) {
                ref.current.blur();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    tabIndex: -1,
                    type: "checkbox",
                    name: name,
                    checked: checked,
                    readOnly: true
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref,
                    tabIndex: 0,
                    onKeyDown: function(evt) {
                        if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                            evt.preventDefault();
                            onChange(evt);
                        }
                    },
                    children: tooltip && !isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover */.J, {
                        triggers: [
                            "hint"
                        ],
                        placement: "top",
                        overlay: (0,translations/* translate */.I)(value, "name").replace("_", " "),
                        children: tooltipContent
                    }) : tooltipContent
                })
            ]
        })
    });
};
ColorCheckbox_ColorCheckbox.displayName = "ColorCheckbox";

;// CONCATENATED MODULE: ./src/@next/components/atoms/ColorCheckbox/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/ColorsFilter/styles.ts

function ColorsFilter_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin: -3px;\n"
    ]);
    ColorsFilter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styles_Wrapper = globalStyles/* styled.div */.zo.div(ColorsFilter_styles_templateObject());

;// CONCATENATED MODULE: ./src/@next/components/molecules/ColorsFilter/ColorsFilter.tsx




var ColorsFilter = function(param) {
    var name = param.name, values = param.values, onValueClick = param.onValueClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: values && values.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorCheckbox_ColorCheckbox, {
                name: name,
                checked: !!value.selected,
                onChange: function() {
                    return onValueClick(value);
                },
                value: value,
                tooltip: true
            }, value.id);
        })
    });
};
ColorsFilter.displayName = "ColorsFilter";

;// CONCATENATED MODULE: ./src/@next/components/molecules/ColorsFilter/index.ts


// EXTERNAL MODULE: ./src/@next/components/molecules/TagsFilter/index.ts + 6 modules
var TagsFilter = __webpack_require__(96985);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedTypes.tsx
var generatedTypes = __webpack_require__(52046);
;// CONCATENATED MODULE: ./src/@next/components/organisms/FilterSidebar/AttributeTypeFilterInput.tsx







// import { Range } from '../../atoms';
var checkIfAttributeIsChecked = function(filters, value, slug) {
    // TODO: fixed eslint error. Check it.
    // if (filters!.attributes && filters.attributes.hasOwnProperty(slug)) {
    if (filters.attributes && slug in filters.attributes) {
        if (filters.attributes[slug].find(function(filter) {
            return filter === value.slug;
        })) {
            return true;
        }
        return false;
    }
    return false;
};
var withSelected = function(filters, values, slug) {
    return values.map(function(value) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            selected: checkIfAttributeIsChecked(filters, value, slug)
        });
    }).filter(function(attr) {
        return attr.slug !== "values" && attr.slug !== "inputtype";
    });
}; // TODO: temp DB fix
function AttributeTypeFilterInput(param) {
    var choiceType = param.choiceType, onFiltersChange = param.onFiltersChange, filters = param.filters, values = param.values, slug = param.slug;
    /* if (choiceType === AttributeChoiceTypeEnum.SLIDER) {
    return (
      <Range
        values={withSelected(filters, values, slug)}
        onChange={(value) => {
          onFiltersChange(slug, value);
        }}
      />
    );
  } */ if (choiceType === generatedTypes/* AttributeChoiceTypeEnum.SWATCH */.O$.SWATCH) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorsFilter, {
            name: slug,
            values: withSelected(filters, values, slug),
            onValueClick: function(value) {
                return onFiltersChange(slug, value.slug);
            }
        });
    }
    if (choiceType === generatedTypes/* AttributeChoiceTypeEnum.DROPDOWN */.O$.DROPDOWN) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsFilter/* TagsFilter */.E, {
            name: slug,
            values: withSelected(filters, values, slug),
            onValueClick: function(value) {
                return onFiltersChange(slug, value.slug);
            }
        });
    }
    return(// fallback to checklist
    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValuesChecklist, {
        name: slug,
        values: withSelected(filters, values, slug),
        onValueClick: function(value) {
            return onFiltersChange(slug, value.slug);
        }
    }));
}

;// CONCATENATED MODULE: ./src/images/close.svg
var close_namespaceObject = __webpack_require__.p + "static/images/close.svg";
;// CONCATENATED MODULE: ./src/@next/components/organisms/FilterSidebar/styles.ts

function FilterSidebar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: center;\n  max-width: calc(425px + 33px * 2);\n  position: relative;\n  margin: 0 auto;\n  padding: 0 33px;\n  overflow-y: auto;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    width: 0px;\n  }\n"
    ]);
    FilterSidebar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterSidebar_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  width: 100%;\n  border: none;\n  padding-bottom: 0;\n  margin-bottom: 34px;\n  margin-top: 44px;\n"
    ]);
    FilterSidebar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 18px;\n    height: 18px;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  font-size: ",
        ";\n  ",
        "\n  color: #ffffff;\n  border-radius: 50%;\n  background-color: #000000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n  span {\n    transform: translateX(0.1em);\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 36px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 50px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 36px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 50px;\n  width: 100%;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 10px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: 20px;\n  line-height: 1.2em;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 32px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: ",
        ";\n  line-height: normal;\n  color: #bdbdbd;\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 13px;\n  min-width: 230px;\n  margin-bottom: 32px;\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 20px;\n    right: 20px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  background-image: url(",
        ");\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 40px;\n  right: 40px;\n  z-index: 1;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var FilterSidebar_styles_Wrapper = globalStyles/* styled.div */.zo.div(FilterSidebar_styles_templateObject());
var styles_Header = globalStyles/* styled.div */.zo.div(FilterSidebar_styles_templateObject1(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
});
var ActiveFilters = globalStyles/* styled.div */.zo.div(styles_templateObject3(), function(props) {
    return props.theme.typography.labelFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject2()));
var FilterGroup = globalStyles/* styled.div */.zo.div(_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject5()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject6()));
var ButtonFilterGroup = globalStyles/* styled.div */.zo.div(_templateObject8());
var FilterTitle = globalStyles/* styled.div */.zo.div(_templateObject11(), function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject9()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject10()));
var ClearButton = globalStyles/* styled.button */.zo.button(_templateObject13(), function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject12()));
var DoneButton = (0,globalStyles/* styled */.zo)(Button/* Button */.z)(_templateObject15(), function(props) {
    return props.theme.typography.labelFontSize;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject14()));
var CloseButton = globalStyles/* styled.button */.zo.button(_templateObject17(), close_namespaceObject, globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject16()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/FilterSidebar/FilterSidebar.tsx











var FilterSidebar = function(param) {
    var hide = param.hide, filters = param.filters, show = param.show, attributes = param.attributes, target = param.target, onFiltersChange = param.onFiltersChange, clearFilters = param.clearFilters, activeFilters = param.activeFilters;
    var intl = (0,useIntl/* default */.Z)();
    var setElementRef = (0,hooks/* useHandlerWhenClickedOutside */.so)(function() {
        hide();
    }).setElementRef;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    var filtersJsx = /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterSidebar_styles_Wrapper, {
        ref: setElementRef(),
        "data-cy": "filter-sidebar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                onClick: hide,
                type: "button"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: intl.formatMessage({
                            defaultMessage: "FILTERS",
                            id: "uqEtJ1"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFilters, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: activeFilters
                        })
                    })
                ]
            }),
            attributes && attributes.map(function(param) {
                var id = param.id, name = param.name, slug = param.slug, values = param.values, translation = param.translation, choiceType = param.choiceType;
                var title = upperFirst_default()((translation === null || translation === void 0 ? void 0 : translation.name) || name || slug).replace("-", " ");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeTypeFilterInput, {
                            choiceType: choiceType,
                            onFiltersChange: onFiltersChange,
                            filters: filters,
                            values: values,
                            slug: slug
                        })
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFilterGroup, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearButton, {
                    type: "button",
                    onClick: clearFilters,
                    children: intl.formatMessage({
                        defaultMessage: "Reset filters",
                        id: "jZ0o74"
                    })
                })
            })
        ]
    });
    return isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        duration: 0,
        position: "bottom",
        show: show,
        hide: hide,
        target: target,
        children: filtersJsx
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        duration: 0,
        position: "left",
        show: show,
        hide: hide,
        target: target,
        children: filtersJsx
    });
};
FilterSidebar.displayName = "FilterSidebar";

;// CONCATENATED MODULE: ./src/@next/components/organisms/FilterSidebar/index.ts


;// CONCATENATED MODULE: ./src/images/filter.svg
var filter_namespaceObject = __webpack_require__.p + "static/images/filter.svg";
;// CONCATENATED MODULE: ./src/@next/components/molecules/FilterButton/FilterButton.tsx

function FilterButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 230px;\n  justify-content: center;\n  position: fixed;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: ",
        ";\n  line-height: ",
        ";\n  letter-spacing: 3px;\n  display: flex;\n  z-index: 1;\n  transition: opacity 0.3;\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n"
    ]);
    FilterButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  & > img {\n    height: 19px;\n    margin-left: 5px;\n  }\n"
    ]);
    FilterButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ButtonWrapper = globalStyles/* styled.div */.zo.div(FilterButton_templateObject(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(param) {
    var isScrolledToBottom = param.isScrolledToBottom;
    return isScrolledToBottom ? 0 : 1;
}, function(param) {
    var isScrolledToBottom = param.isScrolledToBottom;
    return isScrolledToBottom ? "none" : "auto";
});
var FilterButton_Wrapper = globalStyles/* styled.div */.zo.div(FilterButton_templateObject1());
var FilterButton = function(param) {
    var onSubmit = param.onSubmit, isScrolledToBottom = param.isScrolledToBottom;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
        isScrolledToBottom: isScrolledToBottom,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            fullWidth: true,
            onClick: onSubmit,
            size: "sm",
            color: "primary",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton_Wrapper, {
                children: [
                    intl.formatMessage({
                        defaultMessage: "Filter",
                        id: "9Obw6C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: filter_namespaceObject,
                        alt: "filter icon"
                    })
                ]
            })
        })
    });
};
FilterButton.displayName = "FilterButton";

;// CONCATENATED MODULE: ./src/@next/components/molecules/FilterButton/index.tsx


;// CONCATENATED MODULE: ./src/views/Collection/styles.ts

function Collection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n    margin: 150px auto 50px auto;\n  "
    ]);
    Collection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Collection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 80px auto 50px auto;\n    width: 100%;\n    padding: 0 63px;\n  "
    ]);
    Collection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Collection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 60px auto 50px auto;\n    padding: 0 25px;\n  "
    ]);
    Collection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Collection_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 150px auto;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Collection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1492px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1492px;\n  width: 100%;\n  display: flex;\n  margin: auto;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 30px 0 0;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 15px 0 0;\n  "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  position: relative;\n  line-height: 1em;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: lighter;\n  color: ",
        ";\n  letter-spacing: -0.5px;\n  padding: 40px 0 0;\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px 0 12px 0;\n  "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  position: relative;\n  line-height: 1em;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: lighter;\n  color: ",
        ";\n  letter-spacing: -0.5px;\n  padding: 18px 0 18px 0;\n  max-width: 560px;\n  margin-left: auto;\n  margin-right: auto;\n  ",
        "\n  * {\n    font: inherit;\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  //   width: 273px;\n  //   margin-right: 21px;\n  // "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  //   display: none;\n  // "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width: calc(342 / 1492 * 100%);\n  // margin-right: 42px;\n  // flex-shrink: 0;\n  // ",
        "\n  // ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: calc(100vh - 300px);\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}

var Collection_styles_Wrapper = globalStyles/* styled.div */.zo.div(Collection_styles_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(Collection_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(Collection_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(Collection_styles_templateObject2()));
var Collection_styles_Header = globalStyles/* styled.div */.zo.div(styles_templateObject4());
var Content = globalStyles/* styled.div */.zo.div(styles_templateObject5());
var Title = globalStyles/* styled.h1 */.zo.h1(styles_templateObject8(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject7()));
var Excerpt = globalStyles/* styled.div */.zo.div(styles_templateObject10(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject9()));
var Filters = globalStyles/* styled.div */.zo.div(styles_templateObject13(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject11()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject12()));
var styles_ProductList = globalStyles/* styled.div */.zo.div(styles_templateObject14());

;// CONCATENATED MODULE: ./src/views/Collection/Page.tsx




// import { useMediaQuery } from '@hooks/useMediaQuery';
// import { smallScreen } from '@styles/constants';

// import { RudderAnalytics } from '../../app/analitics';
// import { Button } from '@components/atoms/Button';




var Page = function(param) {
    var header = param.header, activeFilters = param.activeFilters, attributes = param.attributes, displayLoader = param.displayLoader, hasNextPage = param.hasNextPage, clearFilters = param.clearFilters, onLoadMore = param.onLoadMore, products = param.products, benefits = param.benefits, filters = param.filters, onFiltersChange = param.onFiltersChange;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useScrolled */.M4)(200, 600), 2), isScrolledTop = ref[0], isScrolledToBottom = ref[1];
    var ref1 = (0,react.useState)(false), showFilters = ref1[0], setShowFilters = ref1[1];
    // const [isSmallScreen] = useMediaQuery(`(max-width: ${smallScreen}px)`);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles_Wrapper, {
        className: "category-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: header.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Excerpt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: header.excerpt
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSidebar, {
                            show: showFilters,
                            hide: function() {
                                return setShowFilters(false);
                            },
                            onFiltersChange: onFiltersChange,
                            attributes: attributes,
                            filters: filters,
                            clearFilters: clearFilters,
                            activeFilters: activeFilters
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ProductList, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* ProductList */.c, {
                            products: products,
                            canLoadMore: hasNextPage,
                            loading: displayLoader,
                            onLoadMore: onLoadMore,
                            benefits: benefits
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton, {
                onSubmit: function() {
                    return setShowFilters(function(state) {
                        return !state;
                    });
                },
                isScrolledToBottom: !isScrolledTop || isScrolledToBottom
            })
        ]
    });
};
Page.displayName = "CategoryPage";
/* harmony default export */ var Collection_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Collection/View.tsx


















var PRODUCTS_PER_PAGE = 100;
var View = function(param) {
    var collection = param.collection, attributes = param.attributes, products = param.products, seo = param.seo, _params = param.params, collectionId = _params.id;
    var locale = (0,router.useRouter)().locale;
    var benefits = (collection === null || collection === void 0 ? void 0 : collection.banners) || [];
    var header = {
        name: (collection === null || collection === void 0 ? void 0 : collection.name) || "",
        excerpt: (collection === null || collection === void 0 ? void 0 : collection.excerpt) || ""
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useQueryState/* useQueryState */.v1)("filters", {
        parse: parseQueryAttributeFilters,
        serialize: serializeQueryAttributeFilters,
        defaultValue: {}
    }), 2), attributeFilters = ref[0], setAttributeFilters = ref[1];
    // State for the filteredProducts
    var ref1 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(products)), filteredProducts = ref1[0], setfilteredProducts = ref1[1];
    // State for the list
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(products.slice(0, PRODUCTS_PER_PAGE))), list = ref2[0], setList = ref2[1];
    // State to trigger load more
    var ref3 = (0,react.useState)(false), loadMore = ref3[0], setLoadMore = ref3[1];
    // State of whether there is more to load
    var ref4 = (0,react.useState)(products.length > PRODUCTS_PER_PAGE), hasMore = ref4[0], setHasMore = ref4[1];
    // Load more button click
    var onLoadMore = function() {
        setLoadMore(true);
    };
    var filters = {
        attributes: attributeFilters,
        pageSize: PRODUCTS_PER_PAGE,
        priceGte: null,
        priceLte: null
    };
    var clearFilters = function() {
        setAttributeFilters({});
    };
    var onFiltersChange = filtersChangeHandler(filters, attributeFilters, setAttributeFilters);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useProductListLazyQuery */.J0)({
        fetchPolicy: "cache-and-network",
        variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            filter: {
                attributes: filters.attributes ? (0,misc/* convertToAttributeScalar */.rh)(filters.attributes) : [],
                collections: collectionId ? [
                    (0,core/* generateKey */.HI)(collectionId, "Collection")
                ] : [],
                price: {
                    gte: filters.priceGte,
                    lte: filters.priceLte
                }
            },
            first: 100
        }, (0,regions/* localeToSaleorQuery */.KK)(locale)), {
            sortBy: null
        })
    }), 2), filterAttributes = ref5[0], ref6 = ref5[1], loading = ref6.loading, data = ref6.data;
    // Handle loading more items
    (0,react.useEffect)(function() {
        if (loadMore && hasMore) {
            var currentLength = list.length;
            var isMore = currentLength < filteredProducts.length;
            var nextResults = isMore ? filteredProducts.slice(currentLength, currentLength + PRODUCTS_PER_PAGE) : [];
            setList((0,_to_consumable_array/* default */.Z)(list).concat((0,_to_consumable_array/* default */.Z)(nextResults)));
            setLoadMore(false);
        }
    }, [
        loadMore,
        hasMore
    ]); //eslint-disable-line
    // Check if there is more
    (0,react.useEffect)(function() {
        var isMore = list.length < filteredProducts.length;
        setHasMore(isMore);
    }, [
        filteredProducts.length,
        list.length
    ]); //eslint-disable-line
    // Reload onFiltersChange
    (0,hooks/* useUpdateEffect */.rf)(function() {
        if (attributeFilters) {
            filterAttributes();
        } else {
            setfilteredProducts(products);
            setList((0,_to_consumable_array/* default */.Z)(products.slice(0, PRODUCTS_PER_PAGE)));
        }
    }, [
        attributeFilters,
        products
    ]); //eslint-disable-line
    // Set the filteredProducts List
    (0,react.useEffect)(function() {
        if (data) {
            var _products = (0,maps/* mapEdgesToItems */.I)(data === null || data === void 0 ? void 0 : data.products);
            setfilteredProducts(_products);
            setList((0,_to_consumable_array/* default */.Z)(_products.slice(0, PRODUCTS_PER_PAGE)));
        }
    }, [
        data
    ]); //eslint-disable-line
    // Track productList Filtered
    (0,hooks/* useUpdateEffect */.rf)(function() {
        var ref;
        // @ analytics
        var productsList = [];
        if (list) {
            productsList = list.map(function(z) {
                return {
                    category: z.category.slug,
                    name: z.productType.slug,
                    product_id: z.slug
                };
            });
        }
        var productsFilters = [];
        if (Object.keys(attributeFilters).length) {
            productsFilters = Object.entries(attributeFilters).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                return {
                    type: k,
                    value: v.join("&")
                };
            });
        }
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track("Product List Filtered", {
            list_id: "category",
            filters: productsFilters,
            products: productsList
        });
    }, [
        list,
        attributeFilters
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_Page, {
                header: header,
                clearFilters: clearFilters,
                attributes: attributes,
                displayLoader: loading,
                hasNextPage: hasMore,
                filters: filters,
                products: list,
                benefits: benefits,
                onFiltersChange: onFiltersChange,
                onLoadMore: onLoadMore,
                activeFilters: filters.attributes ? Object.keys(filters.attributes).length : 0
            })
        ]
    });
};
View.displayName = "CollectionView";
/* harmony default export */ var Collection_View = (View);

;// CONCATENATED MODULE: ./src/views/Collection/index.tsx


;// CONCATENATED MODULE: ./src/pages/collection/[slug]/[id].ts

var __N_SSG = true;
/* harmony default export */ var _id_ = (Collection_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,7453,8626,9774,2888,179], function() { return __webpack_exec__(81542); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);